import { useContext } from "react";

import { ElementVisibilityContext } from "./ElementVisibilityProvider";

/** Hook to access element visibility context. Must be used within ElementVisibilityProvider. */

export const useElementVisibility = () => {
  const context = useContext(ElementVisibilityContext);

  if (context === undefined) {
    throw new Error("useElementVisibility must be used within ElementVisibilityProvider");
  }

  return context;
};
